/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from "@material-ui/icons/Error";
import React, { FunctionComponent } from "react";
import { AppErrorProps } from "./app-error.interfaces";

export const AppError: FunctionComponent<AppErrorProps> = ({
    Icon = ErrorIcon,
    header,
    details,
    children,
    ...rootProps
}: AppErrorProps) => {
    return (
        <Box
            alignItems="center"
            bgcolor="grey.100"
            display="flex"
            flexDirection="column"
            height="100vh"
            justifyContent="center"
            left={0}
            position="fixed"
            top={0}
            width="100vw"
            {...rootProps}
        >
            <Box fontSize={96}>
                <Icon color="disabled" fontSize="inherit" />
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                gridGap={10}
                textAlign="center"
            >
                {header && (
                    <Typography color="textSecondary" variant="h4">
                        {header}
                    </Typography>
                )}

                {details && (
                    <Typography color="textSecondary" variant="body1">
                        {details}
                    </Typography>
                )}
                {children}
            </Box>
        </Box>
    );
};
